import { Pipe } from "@angular/core";
import * as VMasker from "vanilla-masker";

@Pipe({ name: "mask" })
export class MaskPipe {
    definirMascara(valor:string,mascara:string): string {
        let resultado = VMasker.toPattern(valor, mascara);
        return resultado;
    }

    transform(valor: any, mascara: string): string {
        if (!valor || (valor.length && valor.length <= 0)) {
            return "";
        }

        if (mascara === "d.d") {
            return valor.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        }

        let resultado: string = this.definirMascara(valor.toString(), mascara);
        return resultado;
    }

    private limpar(valor: string): string {
        return valor.replace(/[^\w\s]/gi, "").replace(/\s/g, "");
    }
}
